import React from 'react';
import styles from './Skeleton.module.css';

const Skeleton = ({ width, height, className }) => {
    return (
        <div
            className={`${styles.skeleton} ${className || ''}`}
            style={{
                width: width || '100%',
                height: height || '1rem'
            }}
        />
    );
};

export default Skeleton;